import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Wrench, Sun, Shield, Clock, Network, Database } from 'lucide-react';

const ServicesPage = () => (
  <div className="max-w-7xl mx-auto px-4 py-12">
    <h1 className="text-4xl font-bold mb-12 text-center">Our Services</h1>

    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
      {[
        {
          icon: <Wrench className="h-8 w-8" />,
          title: "Electrical Installation",
          description: "Industrial & Domestic electrical wiring installation with comprehensive testing and commissioning."
        },
        {
          icon: <Sun className="h-8 w-8" />,
          title: "Renewable Energy",
          description: "Solar system design, installation, and maintenance for residential and commercial applications."
        },
        {
          icon: <Shield className="h-8 w-8" />,
          title: "Data Centre Infrastructure",
          description: "Networks & Advanced Cyber Security solutions for modern business needs."
        },
        {
          icon: <Network className="h-8 w-8" />,
          title: "Power System Analysis",
          description: "Comprehensive power system evaluation and optimization for industrial and commercial sectors."
        },
        {
          icon: <Database className="h-8 w-8" />,
          title: "Technical Consultancy",
          description: "Expert project evaluation, electrical design, and technical support services."
        },
        {
          icon: <Clock className="h-8 w-8" />,
          title: "Maintenance Services",
          description: "Preventive maintenance, electrical repairs, and after-sales technical support."
        }
      ].map((service, index) => (
        <Card key={index} className="relative overflow-hidden group hover:shadow-lg transition-shadow">
          <CardContent className="p-6">
            <div className="mb-4 text-blue-500">{service.icon}</div>
            <h3 className="text-xl font-semibold mb-2">{service.title}</h3>
            <p className="text-gray-600 mb-4">{service.description}</p>
            <Link 
              to="/contact" 
              className="inline-flex items-center text-blue-500 hover:text-blue-600 transition-colors"
            >
              Learn More
              <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
              </svg>
            </Link>
          </CardContent>
        </Card>
      ))}
    </div>

    <div className="mt-16">
      <Card>
        <CardContent className="p-8">
          <h2 className="text-2xl font-semibold mb-6 text-center">Why Choose Us?</h2>
          <div className="grid md:grid-cols-3 gap-8">
            {[
              {
                icon: <Clock className="h-8 w-8 text-blue-500" />,
                title: "25+ Years Experience",
                description: "Serving Ghana since 1997"
              },
              {
                icon: <Shield className="h-8 w-8 text-blue-500" />,
                title: "Comprehensive Solutions",
                description: "From design to installation and maintenance"
              },
              {
                icon: <Network className="h-8 w-8 text-blue-500" />,
                title: "Technical Expertise",
                description: "Skilled personnel with continuous training"
              }
            ].map((feature, index) => (
              <div key={index} className="text-center">
                <div className="mb-4 mx-auto w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center">
                  {feature.icon}
                </div>
                <h3 className="font-semibold mb-2">{feature.title}</h3>
                <p className="text-gray-600">{feature.description}</p>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  </div>
);

export default ServicesPage;